(() => {
    function setup(root) {
        if (root.dataset.mysteryReady) return;
        const form = root.querySelector('[data-mystery-form]');
        const select = root.querySelector('[data-mystery-variant]');
        let data;
        try {
            data = JSON.parse(root.querySelector('[data-mystery-data]').textContent);
        } catch {
            return;
        }
        if (!form || !select || !Array.isArray(data.variants)) return;
        root.dataset.mysteryReady = 'true';
        const submit = root.querySelector('[data-mystery-submit]');
        const status = root.querySelector('[data-mystery-status]');
        const subject = root.querySelector('[data-mystery-subject]');
        const preferences = form.querySelector('textarea[name="properties[Book preferences]"]');
        const selectionSize = root.querySelector('[data-mystery-selection-size]');
        const selectionNotes = root.querySelector('[data-mystery-selection-notes]');

        function updatePreferencesSummary() {
            if (selectionNotes) selectionNotes.hidden = !preferences?.value.trim();
        }

        preferences?.addEventListener('input', updatePreferencesSummary);
        preferences?.addEventListener('change', updatePreferencesSummary);
        if (preferences?.required) preferences.addEventListener('input', () => preferences.setCustomValidity(''));
        const gift = form.querySelector('[data-mystery-gift]');
        const giftNote = form.querySelector('[data-mystery-gift-note]');
        const giftMessage = form.querySelector('textarea[name="properties[Gift message]"]');

        function updateGift() {
            if (!gift || !giftNote || !giftMessage) return;
            const includeMessage = gift.checked && giftNote.checked;
            form.querySelector('[data-mystery-gift-note-control]').hidden = false;
            form.querySelector('[data-mystery-gift-fallback]').hidden = true;
            form.querySelector('[data-mystery-gift-options]').hidden = !gift.checked;
            giftNote.disabled = !gift.checked;
            form.querySelector('[data-mystery-gift-message]').hidden = !includeMessage;
            giftMessage.disabled = !includeMessage;
            giftMessage.required = includeMessage;
            giftMessage.setCustomValidity('');
        }

        gift?.addEventListener('change', updateGift);
        giftNote?.addEventListener('change', updateGift);
        giftMessage?.addEventListener('input', () => giftMessage.setCustomValidity(''));
        // Let native history restoration finish before disabling dependent fields.
        if (document.readyState === 'complete') updateGift();
        let current;
        let submitting = false;

        function update(announce) {
            current = data.variants.find(variant => variant.id === select.value);
            if (!current) return;
            root.querySelector('[data-mystery-price]').textContent = current.price;
            if (selectionSize) selectionSize.textContent = `${current.size} · ${current.price} per set`;
            updatePreferencesSummary();
            root.querySelectorAll('[data-mystery-media]').forEach(el => {
                el.hidden = el.dataset.mysteryMedia !== current.mediaId;
            });
            root.querySelectorAll('[data-mystery-detail]').forEach(el => {
                el.hidden = el.dataset.mysteryDetail !== current.id;
            });
            submit.disabled = !current.available;
            submit.textContent = current.available ? 'Add mystery box to cart' : 'Currently unavailable';
            if (announce) {
                const url = new URL(location.href);
                url.searchParams.set('variant', current.id);
                history.replaceState(history.state, '', url);
                status.textContent = `${current.size} selected. ${current.price} per set.${current.available ? '' : ' Currently unavailable.'}`;
            }
            // Keep the chosen size when Shopify reloads this product in another market.
            const returnUrl = new URL(location.href);
            returnUrl.searchParams.set('variant', current.id);
            document.querySelectorAll('.sb-country-form input[name="return_to"]').forEach(input => {
                input.value = returnUrl.pathname + returnUrl.search;
            });
        }

        select.addEventListener('change', () => {
            if (submitting) {
                select.value = current.id;
                return;
            }
            update(true);
        });
        if (subject && data.subjects?.length) {
            root.querySelector('[data-mystery-subject-control]').hidden = false;
            subject.addEventListener('change', () => {
                const destination = data.subjects.find(item => item.url === subject.value);
                if (!destination || submitting) return;
                const url = new URL(destination.url, location.origin);
                if (url.origin !== location.origin) return;
                const variant = destination.variants.find(item => item.size === current?.size);
                if (variant) url.searchParams.set('variant', variant.id);
                location.assign(url.href);
            });
        }
        form.addEventListener('submit', event => {
            updateGift();
            if (giftMessage?.required) giftMessage.setCustomValidity(giftMessage.value.trim() ? '' : 'Please enter your gift message, or uncheck the message option.');
            if (preferences?.required) preferences.setCustomValidity(preferences.value.trim() ? '' : 'Please tell us which books you would like.');
            if (submitting || !current?.available || !form.reportValidity()) {
                event.preventDefault();
                return;
            }
            // Shopify's native localized product form is the only cart writer.
            submitting = true;
            form.setAttribute('aria-busy', 'true');
            submit.disabled = true;
            submit.textContent = 'Adding mystery box…';
            status.textContent = 'Adding your mystery box to the cart.';
        });
        window.addEventListener('pageshow', () => {
            if (!root.isConnected) return;
            submitting = false;
            form.removeAttribute('aria-busy');
            status.textContent = '';
            updateGift();
            update(false);
        });
        update(false);
    }

    function start(scope = document) {
        if (scope.matches?.('[data-sb-mystery]')) setup(scope);
        scope.querySelectorAll('[data-sb-mystery]').forEach(setup);
    }

    document.addEventListener('shopify:section:load', event => start(event.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once: true});
    else start();
})();
